import type { Account } from '~/types/api-client'

export const handleDashboardRedirection = (accountDetails: Account) => {
  // FPFX
  if (accountDetails?.platformUser?.user.technologyProvider === 1) return

  if (!accountDetails.tradingPlatformAccountId || !accountDetails?.platformUser?.user.technologyProviderUserId) return

  window.open(
    `/dashboard-url/${accountDetails.tradingPlatformAccountId}/${accountDetails?.platformUser?.user.technologyProviderUserId}`,
  )
}
